import styled, { css } from 'styled-components';

import { ErrorText, StyledLabel } from '../TextFieldAtom/TextFieldAtom.styled';

/* ----------------------------- StyledLabel ----------------------------- */

export const TextLabel = styled.span(
    ({ theme }) => `
        display: inline-block;
        margin-left: 2.4rem;
        color: ${theme.sections.page.a};
        line-height: 120%;
        cursor: pointer;
        margin-top: 0.3rem;
    `,
);

export const CheckBox = styled.input(
    ({ theme }) => `
        border: 0.06rem solid ${theme.sections.medium};
        background-color: ${theme.sections.light};
        position: absolute;
        left: 0;
        top: 0;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0;
        margin: 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.3rem;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        &:after {
            font-family: 'EtvConsumerApps';
            content: '\\f02d';
            color: ${theme.sections.dark};
            opacity: 0;
            transition: opacity 0.33s;
            font-weight: 900;
            font-size: 0.875rem;
            margin-top: 0.125rem;
        }

        &:checked {
            border: 0.06rem solid ${theme.sections.medium};
            background-color: ${theme.sections.light};
        }

        &:checked:after {
            opacity: 1;
        }

        &:focus, &:active {
            border-color: ${theme.sections.page.feature};
        }

    `,
);

export const StyledCheckboxLabel = styled(StyledLabel)(
    ({ theme, hasError }) => [
        css`
            position: relative;
            padding-bottom: 1.5rem;
            display: block;
        `,
        hasError &&
            css`
                ${TextLabel} {
                    color: ${theme.sections.negative};
                }
            `,
        `        ${ErrorText}{
                margin: 0.5rem 0 0 2.4rem;
                text-align: left;
            }`,
    ],
);
